<template>
<div class="chapter">
<div class="inner_page">
<div class="section level2" id="artefacts">
<h2>Artefacts</h2>
<p>The vibrant hues of summer slowly beginning to fade like those of a photograph. One that’s been lingered over in deep contemplation… A desire and longing to prolong those cherished moments.</p>
<p>Shadows are cast in the heat of the setting sun, stretching with the lithe grace of a dancer across the earth. Was that you walking by? My eyes deceive me.</p>
<p>Memories of warm nights gazing far out across the barren land. Majestic landscapes by the sea. The sweet sound of your laughter still ringing in my ears. Fingers laced, we’d stroll along the shore. Ruminating on philosophy, art and life.</p>
<p>We marvelled at ancient artefacts whose mystery intrigued. Stories of a past we’d never fully grasp. My eyes catch sight of an untouched bowl of pomegranates on the table. The unfinished bottle of wine. Artefacts in their own right. Keepers of the secrets we shared. Tokens of moments we’d wished would never come to an end.</p>
<p>The sweet autumn air fills my lungs. I close my eyes, allowing its gentle touch to envelop me…just as your arms did not long before. A soft smile comes to my lips, as I concede to the delicate melody of autumn, knowing I shall always carry with me the memory of that summer.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?29a77d6d